module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hNKWc"))).then(() => parcelRequire('ikE14'));